<template lang="pug">
section.src-components-hello-world 
  v-container
    h1 Generador de archivo wsaa_client
      v-form(ref='form')
        .d-flex.flex-wrap
          v-file-input.ma-1(label='Leer wsaa_client.properties' accept='.properties,text/plain' @change='handleFileUpload')
          v-select.ma-1(label='Tipo IVA Emisor' v-model='tipoIVAEmisor' :items='tiposIva')
          v-text-field.ma-1(label='Punto de Venta' v-model='PTOVTA')
          v-text-field.ma-1(label='CUIT' v-model='CUIT')
          v-text-field.ma-1(label='Razón Social' v-model='razonSocial')
          v-text-field.ma-1(label='IIBB' v-model='IIBB')
          v-text-field.ma-1(label='Impresora' v-model='impresora')
          .d-flex.ma-1
            span Inicio de Actividad:
            Datepicker(:startDate="inicioActividad" @date="changeDate($event)")
          v-text-field.ma-1(label='Dirección Línea 1' v-model='direccionL1')
          v-text-field.ma-1(label='Dirección Línea 2' v-model='direccionL2')
          v-text-field.ma-1(label='Header Línea 1' v-model='headerL1')
          v-text-field.ma-1(label='Header Línea 2' v-model='headerL2')
          v-text-field.ma-1(label='Header Línea 3' v-model='headerL3')
          v-text-field.ma-1(label='Header Línea 4' v-model='headerL4')
          v-text-field.ma-1(label='Pie Línea 1' v-model='pieL1')
          v-text-field.ma-1(label='Pie Línea 2' v-model='pieL2')
          v-text-field.ma-1(label='Pie Línea 3' v-model='pieL3')
          v-text-field.ma-1(label='Pie Línea 4' v-model='pieL4')
          v-text-field.ma-1(label='ID Cliente' v-model='idCliente')
          v-checkbox.ma-1(v-model="ivaincluido_facturaA" label="Iva Incluido en Factura A (Axeventas Si, GG No)" value="1" false-value="0")
        v-btn(@click='generarArchivo') Generar archivo  

</template>

<script lang="js">
  import Datepicker from './Datepicker.vue'
  function parseProperties(contenido) {
    const datos = {}
    contenido.split(/\r?\n/).forEach((linea) => {
      const lineaLimpia = linea.trim()
      if (!lineaLimpia || lineaLimpia.startsWith('#')) {
        return
      }
      const idx = lineaLimpia.indexOf('=')
      if (idx === -1) {
        return
      }
      const clave = lineaLimpia.slice(0, idx).trim()
      const valor = lineaLimpia.slice(idx + 1)
      datos[clave] = valor
    })
    return datos
  }
  function generarArchivo(data) {
    // Datos fijos
    const datosFijos = {
      dstdn: 'cn=wsaa,o=afip,c=ar,serialNumber=CUIT 33693450239',
      endpoint: 'https://wsaa.afip.gov.ar/ws/services/LoginCms',
      token: '',
      sign: '',
      tokenExpiresDate: '0',
      service: 'wsfe',
      keystore: 'certs/private/'+data.CUIT.replace(/-/g,'')+'.jks',
      'keystore-password': 'sistemas12',
      http_proxy_port:'',
      http_proxy:'',
      usaA4:0,
      usaTicket:1,
      enviaEmail:0,
      'keypair-password': 'sistemas12',
      signer:1,
      'keystore-signer':1
    }

    // Combinar datos fijos y datos introducidos por el usuario
    data.inicioActividad = data.inicioActividad.replace(/-/g,'')
    const datosCombinados = Object.assign({}, datosFijos, data)

    // Generar contenido del archivo
    let contenido = ''
    for (const clave in datosCombinados) {
      contenido += `${clave}=${datosCombinados[clave]}\n`
    }

    return contenido
  }
  function saveAs(contenido, nombreArchivo) {
    // Convertir el contenido a un objeto Blob
    const blob = new Blob([contenido], {type: 'text/plain'})

    // Crear una URL para el objeto Blob
    const url = URL.createObjectURL(blob)

    // Crear un enlace para descargar el archivo
    const enlace = document.createElement('a')
    enlace.href = url
    enlace.download = nombreArchivo

    // Agregar el enlace al cuerpo del documento y hacer clic en él
    document.body.appendChild(enlace)
    enlace.click()

    // Eliminar el enlace del cuerpo del documento
    document.body.removeChild(enlace)

    // Revocar la URL del objeto Blob
    URL.revokeObjectURL(url)
  }
  export default  {
    name: 'src-components-hello-world',
    props: [],
    components: {Datepicker},
    mounted () {

    },
    data () {
      return {
        tiposIva:[{text:'Responsable Inscripto',value:0},{text:'Monotributo',value:5}],
        tipoIVAEmisor: 0,
        PTOVTA: 3,
        CUIT: '30-00000000-7',
        razonSocial: 'RAZON SOCIAL',
        IIBB: '30-00000000-7',
        impresora: 'CAJA',
        inicioActividad: '2022-12-01',
        pieL4: '',
        prod: 1,
        pieL3: '',
        pieL2: '',
        pieL1: '',
        direccionL2: '1176-CIUDAD AUTONOMA BUENOS AIRES',
        direccionL1: '',
        headerL4: '',
        headerL3: '',
        headerL2: '',
        headerL1: 'NOMBRE FANTASIA',
        idCliente: 1,
        ivaincluido_facturaA:0,
      }
    },
    methods: {
      changeDate(fecha) {
        this.inicioActividad = fecha
      },
      handleFileUpload (archivo) {
        if (!archivo) {
          return
        }
        const lector = new FileReader()
        lector.onload = (evento) => {
          const contenido = evento.target.result
          const propiedades = parseProperties(contenido)
          this.aplicarPropiedades(propiedades)
        }
        lector.readAsText(archivo)
      },
      aplicarPropiedades (propiedades) {
        const clavesPermitidas = new Set([
          'tipoIVAEmisor',
          'PTOVTA',
          'CUIT',
          'razonSocial',
          'IIBB',
          'impresora',
          'inicioActividad',
          'pieL4',
          'prod',
          'pieL3',
          'pieL2',
          'pieL1',
          'direccionL2',
          'direccionL1',
          'headerL4',
          'headerL3',
          'headerL2',
          'headerL1',
          'idCliente',
          'ivaincluido_facturaA'
        ])

        Object.keys(propiedades).forEach((clave) => {
          if (!clavesPermitidas.has(clave)) {
            return
          }
          let valor = propiedades[clave]
          if (clave === 'inicioActividad') {
            if (/^\d{8}$/.test(valor)) {
              valor = valor.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
            }
          }
          if (clave === 'tipoIVAEmisor' || clave === 'PTOVTA' || clave === 'idCliente' || clave === 'prod') {
            const numero = Number(valor)
            valor = Number.isNaN(numero) ? valor : numero
          }
          if (clave === 'ivaincluido_facturaA') {
            valor = valor === '1' ? 1 : 0
          }
          this[clave] = valor
        })
      },
      generarArchivo () {
        const data = {
          tipoIVAEmisor: this.tipoIVAEmisor,
          PTOVTA: this.PTOVTA,
          CUIT: this.CUIT,
          razonSocial: this.razonSocial,
          IIBB: this.IIBB,
          impresora: this.impresora,
          inicioActividad: this.inicioActividad,
          pieL4: this.pieL4,
          prod: this.prod,
          pieL3: this.pieL3,
          pieL2: this.pieL2,
          pieL1: this.pieL1,
          direccionL2: this.direccionL2,
          direccionL1: this.direccionL1,
          headerL4: this.headerL4,
          headerL3: this.headerL3,
          headerL2: this.headerL2,
          headerL1: this.headerL1,
          idCliente: this.idCliente,
          ivaincluido_facturaA: this.ivaincluido_facturaA
        }

        // Validar datos (opcional)

        // Generar archivo
        const contenido = generarArchivo(data)
        const archivo = new File([contenido], 'wsaa_client.properties', {type: 'text/plain'})
        saveAs(archivo,'wsaa_client.properties')
      },      
    },
    computed: {

    }
}


</script>

<style scoped lang="scss">
  .src-components-hello-world {

  }
</style>
